import { render, staticRenderFns } from "./ProductFormVariantAvailability.vue?vue&type=template&id=2405f6f6&"
import script from "./ProductFormVariantAvailability.vue?vue&type=script&lang=js&"
export * from "./ProductFormVariantAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports